import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResolverService } from 'src/app/core';
import { SnackBarService } from 'src/app/shared';
import { environment } from 'src/environments/environment';
import { GiftCardsFacadeService } from '../../services/gift-cards-facade.service';
import { Profile } from 'src/app/core/models/initials.model';

@Component({
  selector: 'app-accessory-order-detail',
  templateUrl: './accessory-order-detail.component.html',
  styleUrls: ['./accessory-order-detail.component.scss']
})
export class AccessoryOrderDetailComponent implements OnInit {
  orderDetails: any;
  invoiceItems: any;
  titles: string[] = ['No.', /*'Company',*/ 'Product', 'Quantity', 'Unit Price', 'Total Price']
  topLevelUser: Profile;
  orderUserData: Profile;
  isAdmin: boolean = false;
  showInvoiceHeader: boolean = false;
  piNumber: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private giftCardService: GiftCardsFacadeService,
    private snackbarService: SnackBarService,
    private resolvedService: ResolverService,
  ) { }

  ngOnInit(): void {
    this.getUrlData();
    // if (this.resolvedService.userInitInfo.profile.role.role_id == environment.role_types.admin) {
    //   this.piNumber = window.prompt('Enter PI Number(Optional)')
    // }
  }

  getUrlData() {
    this.activatedRoute.params.subscribe(
      params => {
        const id = params.id;
            this.showInvoiceHeader = false;
            this.getOrderDetails(id);
            this.setupHeaderData();
      }
    )
  }


  setupHeaderData() {
    this.topLevelUser = { ...this.resolvedService.userInitInfo.profile };
      if (!this.topLevelUser.reseller) {
        this.showInvoiceHeader = true;
        this.topLevelUser.company = environment.title;
        this.topLevelUser.address = `7940 Silverton Ave. Suite 101-A
                San Diego, CA 92126`;
        this.topLevelUser.company_logo = environment.logoPrintSrc;
        this.topLevelUser.email = environment.email;
        this.topLevelUser.phone = environment.webUrl;
      } else {
        this.showInvoiceHeader = true;
        this.topLevelUser = { ...this.resolvedService.userInitInfo.profile.reseller }
      }
  }

  getOrderDetails(id: number) {

    this.giftCardService.getAccessoryOrderDetail(id).subscribe(
      details => {
        this.orderDetails = details;
          this.orderUserData = this.resolvedService.userInitInfo.profile;
      },
      error => {
        this.snackbarService.showSnack(error.detail);
      }
    )
  }

  getLocalTimezone() {
    return this.resolvedService.userInitInfo.profile.timezone_data ? this.resolvedService.userInitInfo.profile.timezone_data.code : 'UTC';
  }

  printInvoice() {
    window.print();
  }


  calcRemainingBalance() {
    return this.orderDetails.remaining_balance - this.orderDetails.credits;
  }

  calcTotal() {
    if (this.invoiceItems) {
      return this.invoiceItems.reduce((sum, current) => sum + (current.count * current.unit_price), 0)
    }
  }

}
